(function () {
    'use strict';

    var $ = window.jQuery;
    var sport = null;

    function Gallery(options) {
        if (!options) {
            throw new Error('No options passed to Gallery constructor.');
        }

        this.options = $.extend({}, Gallery.defaults, options);
        this.initSelectors();
        this.initOrderSorting();
        this.initLoadMoreButton();
    }

    Gallery.prototype.initSelectors = function () {
        var $self = this;
        $('#sports_select').on('change', function () {
            var path = document.location.protocol + "//" + document.location.hostname + '/' + $self.options.baseUrl;
            if ($(this).val().length === 0) {
                window.location.href = path;
            } else {
                window.location.href = path + '/sport/' + $(this).val();
            }
        });
    };

    Gallery.prototype.initOrderSorting = function () {
        $('#order_sorting').on('change', function () {
            var path = document.location.protocol + "//" + document.location.hostname + document.location.pathname;
            window.location.href = path + '?sort=' + $(this).val();
        });
    };

    Gallery.prototype.initLoadMoreButton = function () {

        $('#loadMore').on('click', function (e) {
            if ($(this).hasClass('isDisabled')) {
                e.preventDefault();
            } else {
                e.preventDefault();
                var offset = $(this).data('offset');
                var sort = $(this).data('sort');
                sport = $(this).data('sport');

                $(this).prop('disabled', true).addClass('isDisabled');

                $.ajax({
                    type: 'GET',
                    url: '/wp-json/arkansas/v2/load_gallery',
                    data: {
                        offset: offset,
                        sport: sport,
                        sort: sort
                    },
                    success: function (response) {
                        if (response.count > 0) {
                            offset += response.count;
                            $('#infinite-container').append(response.data);
                            $('#loadMore')
                                .data('offset', offset)
                                .prop('disabled', false)
                                .removeClass('isDisabled');
                        }

                        if (response.is_full) {
                            $('#loadMore').fadeOut();
                        }
                    },
                    error: function (data) {

                    }
                });
            }
        });
    };

    window.Gallery = Gallery;

}());